import type { DxtradeInstrumentQuery } from '@model/DxTrade.types'

export function prepareDxtradeInstrumentQueryParams(
  query?: DxtradeInstrumentQuery
): URLSearchParams {
  const params = new URLSearchParams()

  if (!query) {
    return params
  }

  if (query.limit && query.limit > 0) {
    params.set('limit', String(query.limit))
  }

  if (typeof query.startFrom === 'number' && query.startFrom >= 0) {
    params.set('start-from', String(query.startFrom))
  }

  const normalizedSymbols = query.symbols?.trim()
  if (normalizedSymbols) {
    params.set('symbols', normalizedSymbols)
  }

  const normalizedSymbolDescription = query.symbolDescription?.trim()
  if (normalizedSymbolDescription) {
    params.set('symbolDescription', `*${normalizedSymbolDescription}*`)
  }

  if (query.assetClass) {
    params.set('assetClass', query.assetClass)
  }

  if (query.types?.length) {
    params.set('types', query.types.join(','))
  }

  return params
}
